// import Swiper JS
import Swiper from 'swiper';
import { Pagination, A11y } from 'swiper/modules';


// init Swiper:
const swiper = new Swiper('.swiper-homepage', {
    modules: [Pagination, A11y],
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    a11y: {
        paginationBulletMessage: 'Ga naar slide {{index}}',
    },
});
